import { InteractiveQuestionType } from '@genially/document-model';

import type { UserQuestionProps } from '../../hooks/useFetchUserTrackingData/models/UserQuestion';

export const processHits = (questions: UserQuestionProps[]): string => {
  const scoreableQuestions = questions.filter(({ type }) =>
    [
      InteractiveQuestionType.Quiz,
      InteractiveQuestionType.TrueFalse,
      InteractiveQuestionType.Image,
      InteractiveQuestionType.Sort,
      InteractiveQuestionType.FillInTheBlanks,
      InteractiveQuestionType.ShortAnswer,
    ].includes(type),
  );

  const hits = scoreableQuestions.reduce(
    (h, { isCorrect }) => (isCorrect ? h + 1 : h),
    0,
  );

  return `${hits}/${scoreableQuestions.length}`;
};
